import Search from "../../components/Search";


export default function SearchPage() {
    return (
        <Search />
    )
};